var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUvdFavicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0390625 12.8933H14.4857C15.3436 12.8933 16.0391 13.5888 16.0391 14.4467C16.0391 15.3046 15.3436 16 14.4857 16H0.0390625V12.8933Z",
    fill: "#009EF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0390625 6.40723H11.6038C12.4618 6.40723 13.1572 7.10269 13.1572 7.96059C13.1572 8.81849 12.4617 9.51396 11.6038 9.51396H0.0390625V6.40723Z",
    fill: "#009EF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0390625 0H14.4857C15.3436 0 16.0391 0.695466 16.0391 1.55337C16.0391 2.41127 15.3436 3.10673 14.4857 3.10673H0.0390625V0Z",
    fill: "#009EF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUvdFavicons);
export default __webpack_public_path__ + "static/media/uvd-favicons.048841ed078a3c353851fb7f5bf110e7.svg";
export { ForwardRef as ReactComponent };